import { COMMIT_SELECTIONS } from "state/selections/actionTypes";
import {
  RECEIVE_CASH_FLOW_DATA,
  REQUEST_CASH_FLOW_DATA,
  SET_DEFINITION,
  SET_DEFINITIONS,
} from "./actions";
import SelectionState from "state/selections/SelectionState";
import {
  removeDefinitionFromState,
  setDefinitionToState,
} from "state/grid/utils";
import { DELETE_COLUMN } from "state/grid/actions";
import produce from "immer";

const defaultState = {
  definitions: {
    [SelectionState.UNCOMMITTED]: [],
    [SelectionState.COMMITTED]: [],
  },
  fetchingCashFlowData: false,
  cashFlowData: null,
  periodOptions: [
    {
      label: "30D",
      value: "p30dCashFlow",
    },
    {
      label: "90D",
      value: "p90dCashFlow",
    },
    {
      label: "365D",
      value: "p365dCashFlow",
    },
    {
      label: "YTD",
      value: "ytdCashFlow",
    },
  ],
  typeOptions: [
    {
      label: "Net Cash Flow",
      value: "netCashFlow",
    },
    {
      label: "Pct Net Cash Flow to MV",
      value: "pctNetCashFlowToMV",
    },
  ],
};

const reducer = produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_DEFINITION:
      return setDefinitionToState(state, action.idx, action.definition);

    case DELETE_COLUMN:
      return removeDefinitionFromState(state, action.payload);

    case SET_DEFINITIONS:
      state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
      break;

    case COMMIT_SELECTIONS:
      state.cashFlowData = defaultState.cashFlowData;
      state.definitions[SelectionState.COMMITTED] =
        state.definitions[SelectionState.UNCOMMITTED];
      break;

    case REQUEST_CASH_FLOW_DATA:
      state.fetchingCashFlowData = true;
      state.cashFlowData = defaultState.cashFlowData;
      break;

    case RECEIVE_CASH_FLOW_DATA:
      state.fetchingCashFlowData = false;
      state.cashFlowData = action.data;
      break;

    default:
      return state;
  }
});
export default reducer;
